import { resolveMediaUrl } from '../api/baseUrl';
import cityBg from '../../Assets/images/cityBg.webp';
import jamaicaImg from '../../Assets/images/cities/Jamaica.webp';
import jacksonvilleImg from '../../Assets/images/cities/Jacksonville.webp';
import orlandoImg from '../../Assets/images/cities/Orlando.webp';
import sanJuanImg from '../../Assets/images/cities/San Juan Puerto Rico.webp';
import trinidadImg from '../../Assets/images/cities/Trinidad.webp';

const CITY_IMAGE_MAP = {
    jacksonville: jacksonvilleImg,
    jamaica: jamaicaImg,
    orlando: orlandoImg,
    'san juan': sanJuanImg,
    'puerto rico': sanJuanImg,
    trinidad: trinidadImg,
    'trinidad & tobago': trinidadImg,
    'montego bay': jamaicaImg,
    kingston: jamaicaImg,
};

export const getTourImageUrl = (imagePath, fallback = cityBg) => {
    return resolveMediaUrl(imagePath) || fallback;
};

export const getCityLocalImage = (cityName, fallback = cityBg) => {
    if (!cityName) return fallback;
    const key = String(cityName).trim().toLowerCase();
    return CITY_IMAGE_MAP[key] || fallback;
};

/**
 * Map TourCardDto (API) to DestinationCard props.
 */
export const parseTourTags = (tags) => {
    if (!tags) return [];
    if (Array.isArray(tags)) {
        return tags
            .map((tag) => String(tag ?? '').trim())
            .filter(Boolean)
            .slice(0, 2);
    }
    return String(tags)
        .split(',')
        .map((tag) => tag.trim())
        .filter(Boolean)
        .slice(0, 2);
};

export const mapTourCardToUi = (tour) => {
    if (!tour) return null;
    return {
        id: tour.id ?? tour.Id,
        image: getTourImageUrl(tour.coverImage ?? tour.CoverImage, cityBg),
        title: tour.name ?? tour.Name ?? '',
        desc: tour.shortDescription ?? tour.ShortDescription ?? '',
        reviews: tour.reviewCount ?? tour.ReviewCount ?? 0,
        price: tour.price ?? tour.Price ?? 0,
        pricingModel: Number(tour.pricingModel ?? tour.PricingModel ?? 1),
        rating: tour.rating ?? tour.Rating ?? 0,
        destination: tour.destination ?? tour.Destination,
        durationLabel: tour.durationLabel ?? tour.DurationLabel,
        slug: tour.slug ?? tour.Slug,
        tags: parseTourTags(tour.tags ?? tour.Tags),
    };
};

export const mapTourCardsToUi = (tours) => {
    if (!Array.isArray(tours)) return [];
    return tours.map(mapTourCardToUi).filter(Boolean);
};
